import { render, staticRenderFns } from "./inspect-data.vue?vue&type=template&id=16c28a21"
import script from "./inspect-data.vue?vue&type=script&lang=js"
export * from "./inspect-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports